import React from 'react';
import OptionsButton, { IButtonOption } from '../../../../../../../global/options-button/options-button';

interface IProps {
    label: JSX.Element;
    options: IButtonOption[];
}

const KnoviodOptionsButton: React.FC<IProps> = ({ label, options }) => {
    return options.length ? (
        <OptionsButton
            className='options-button--right-margin-auto'
            modifier={['fat', 'options']}
            label={label}
            options={options}
            position='top'
            align='start'
        />
    ) : null;
};

export { KnoviodOptionsButton };
